/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
*/

import {
  Component, forwardRef, Input, OnInit,
} from '@angular/core';
import {
  ControlValueAccessor, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { MenuItem } from '../types';

@Component({
  selector: 'bulb-menubar',
  templateUrl: './menubar.component.html',
  styleUrls: ['./menubar.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MenubarComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class MenubarComponent implements OnInit, ControlValueAccessor {
  @Input() menuItems: MenuItem[];

  onChange = (value: any) => {};

  onTouched = () => {};

  private value: any;

  formGroup: UntypedFormGroup;

  constructor(private fb: UntypedFormBuilder) { }

  writeValue(value: any): void {
    this.value = value;
    this.onChange(value);
    this.menuItems.filter(({ model }) => model).forEach((menuItem) => {
      this.formGroup.patchValue({
        [menuItem.model]: value,
      });
    });
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  ngOnInit() {
    this.formGroup = this.fb.group({});
    this.menuItems.filter(({ model }) => model).forEach((menuItem) => {
      this.formGroup.addControl(menuItem.model, new UntypedFormControl(this.value));
    });
    // TODO: unsubscribe
    this.formGroup.valueChanges.subscribe((value) => {
      const key = Object.keys(value)[0];
      this.onChange(value[key][key]);
    });
  }
}
